import dayjs from 'dayjs';
import * as yup from 'yup';

import { DateFormat } from '@/shared/libs/time.lib';

export const dateField = yup
  .string()
  .required('Date is required')
  .transform((value) => {
    if (!value) {
      return value;
    }
    const date = dayjs(value);
    return date.isValid() ? date.format(DateFormat.Calendar) : value;
  })
  .test('valid-date', 'Please enter a valid date', (value) => {
    if (!value) {
      return true;
    }
    return dayjs(value).isValid();
  });
